<template>
    <div class="c-office-filter-dropdown">
        <button class="c-office-filter-dropdown__button" :class="{'c-office-filter-dropdown__button--active': dropdownOpen}" @click=results()>
            <div v-if="tag.includes('departments')" class="c-office-filter-dropdown__button-tag">Välj avdelning</div>
            <div v-else-if="tag === 'plats'" class="c-office-filter-dropdown__button-tag">{{ selectArea }}</div>
            <div v-else class="c-office-filter-dropdown__button-tag">{{selecttag}}</div>
            <div class="c-office-filter-dropdown__button-text">{{ buttonText }}</div>
            <div aria-hidden="true" class="c-icon c-icon--xs c-office-filter-dropdown__toggle-icon">
                <svg v-if="!dropdownOpen"><use :xlink:href="`#icon-plus`"></use></svg>
                <svg v-else><use :xlink:href="`#icon-minus`"></use></svg>
            </div>
        </button>
        <slot/>
    </div>
</template>

<script>
export default {
    name: 'VOfficeFilterDropdown',
    props: {
		tag: {
			type: String,
			required: false
		},
        selecttag: {
          type: String,
          required: false  
        },
        buttonText: {
            type: String,
            required: true
        },
        dropdownOpen: {
            type: Boolean,
            required: true
        },
        selectArea: {
            type: String
        },
        select: {
            type: String
        }   
	},
    data() {
        return {
        }
    },

    methods: {
        results() {
            this.$emit('populate-filter', [{dropdownOpen: this.dropdownOpen}, {tag: this.tag}])
        }
    }
}
</script>
